import React, { useState } from "react";
import "./productPage.css";
import { verifyLicenseStatus } from "../../utils/license-utils";
import { useHistory } from "react-router-dom";
import { openDeepLink } from "../../utils/openDeepLink";
import { encryptData } from "../../components/Common/EncryptDecrypt";

import iconPlatform from "../../img/product/fireflink_platform.svg";
import iconCloud from "../../img/product/fireflink_cloud.svg";
import iconFinder from "../../img/product/fireflink_finder.svg";
import iconForce from "../../img/product/fireflink_force.svg";

import iconPlatformHover from "../../img/product/ff-platform-hover.svg";
import iconCloudHover from "../../img/product/ff-cloud-hover.svg";
import iconFinderHover from "../../img/product/ff-finder-hover.svg";
import iconForceHover from "../../img/product/ff-force-hover.svg";

const DOMAIN_URL = process.env.REACT_APP_MANAGEMENT_DOMAIN_NAME;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "";

const ProductListBanner = () => {
  const history = useHistory();
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const handlenavigation = (product) => {
    let response = JSON.parse(localStorage.getItem("login-user"));

    switch (product) {
      case "Fireflink-Platform":
      case "Fireflink-Force":
        if (response) {
          encryptData(response)
            .then((result) => {
              const licenseType = response.licenseType;
              let url = verifyLicenseStatus(response)
                ? `${DOMAIN_URL}/projectmenu/project?from="website"&data=${result}&licenseType=${licenseType}`
                : `${DOMAIN_URL}/licenses/fireflink-license?from="website"&data=${result}&licenseType=${licenseType}`;
              window.open(url);
            })
            .catch((err) => {
              console.error("Encryption failed", err);
            });
        }
        break;

      case "Device-Farm":
        window.open(`https://devicefarm.fireflink.com/login`);
        break;
      case "Fireflink-Assets":
        // window.open(`/fireflink-assets`);
        history.push(`/fireflink-assets`);
        break;
      case "Fireflink-Finder":
        openDeepLink(
          "openfireflinkclient://",
          "/fireflink-finder/#download",
          history,
        );
        break;

      default:
        break;
    }
  };
  const products = [
    {
      id: "Fireflink-Platform",
      title: "FireFlink Platform",
      description:
        "Next-gen AI-powered platform for script less test automation, enabling 4X faster and extreme automation.",
      icon: iconPlatform,
      hoverIcon: iconPlatformHover || iconPlatform,
    },
    ...(ENVIRONMENT !== "production-sg"
      ? [
          {
            id: "Device-Farm",
            title: "FireFlink Device Farm",
            description:
              "FireFlink Device Farm - A Unified Cloud for Device-Driven Automation",
            icon: iconCloud,
            hoverIcon: iconCloudHover || iconCloud,
          },
        ]
      : []),
    {
      id: "Fireflink-Finder",
      title: "FireFlink Finder",
      description:
        "One-click UI-element locator generation. Generate multiple optimal locators for a variety of apps, with a single unified tool.",
      icon: iconFinder,
      hoverIcon: iconFinderHover || iconFinder,
    },
    // {
    //   id: "Fireflink-Force",
    //   title: "FireFlink Force",
    //   description:
    //     "Next-gen-AI-Powered platform for scriptless test automation, enabling 12X Faster and extreme automation.",
    //   icon: iconForce,
    //   // hoverIcon: iconForceHover || iconForce,
    // },
  ];

  return (
    <section className="product-section">
      <div className="product-container">
        {/* Main Section Header */}
        <div className="product-header">
          <div className="product-header-title">
            Explore FireFlink’s comprehensive suite of offerings
          </div>
          <div className="product-header-desc">
            FireFlink simplifies test automation by consolidating all your needs
            into one platform, eliminating the hassle of multiple tools and
            dependencies
          </div>
        </div>

        {/* Grid Container */}
        <div className="product-grid-container">
          <div className="product-grid">
            {products.map((product) => (
              <div
                key={product.id}
                className="product-card"
                onClick={() => handlenavigation(product.id)}
                onMouseEnter={() => setHoveredProduct(product.id)}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                {/* Card Header: Icon + Title */}
                <div className="card-header-row">
                  <div className="product-icon-wrapper">
                    <img
                      src={
                        hoveredProduct === product.id
                          ? product.hoverIcon
                          : product.icon
                      }
                      alt={`${product.title} icon`}
                      className="product-icon-img"
                    />
                  </div>
                  <div className="product-card-title">{product.title}</div>
                </div>

                {/* Description below */}
                <div className="product-card-desc">{product.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductListBanner;
